
        var result = require("!!../../../../node_modules/css-loader/index.js!./dashboard4.template.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dashboards/dashboard4.template.css
// module id = 1486
// module chunks = 0